const Helper = {
  extensao (valor) {
    switch (valor) {
      case '10':
        return 'Dez'
      case '11':
        return 'Onze'
      case '12':
        return 'Doze'
      case '13':
        return 'Treze'
      case '14':
        return 'Catorze'
      case '15':
        return 'Quinze'
      case '16':
        return 'Dezasseis'
      case '17':
        return 'Dezassete'
      case '18':
        return 'Dezoito'
      case '19':
        return 'Dezanove'
      case '20':
        return 'Vinte'
      case 10:
        return 'Dez'
      case 11:
        return 'Onze'
      case 12:
        return 'Doze'
      case 13:
        return 'Treze'
      case 14:
        return 'Catorze'
      case 15:
        return 'Quinze'
      case 16:
        return 'Dezasseis'
      case 17:
        return 'Dezassete'
      case 18:
        return 'Dezoito'
      case 19:
        return 'Dezanove'
      case 20:
        return 'Vinte'

      default:
        return 'Valor inválido'
    }
  },
  monthName () {
    let d = new Date()
    let month = []
    month[0] = 'Janeiro'
    month[1] = 'Fevereiro'
    month[2] = 'Maço'
    month[3] = 'Abril'
    month[4] = 'Maio'
    month[5] = 'Junho'
    month[6] = 'Julho'
    month[7] = 'Agosto'
    month[8] = 'Setembro'
    month[9] = 'Outubro'
    month[10] = 'Novembro'
    month[11] = 'Dezembro'
    return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
  },
  dia () {
    var day = new Date()
    day = day.getDate()
    day = day.toString()
    return day
  },
  inverterData (dateString) {
    var p = dateString.split('-')
    // eslint-disable-next-line standard/array-bracket-even-spacing
    return [p[2], p[1], p[0] ].join('/')
  },
  presente_data () {
    var d = new Date()
    var month = []
    month[0] = 'Janeiro'
    month[1] = 'Fevereiro'
    month[2] = 'Maço'
    month[3] = 'Abril'
    month[4] = 'Maio'
    month[5] = 'Junho'
    month[6] = 'Julho'
    month[7] = 'Agosto'
    month[8] = 'Setembro'
    month[9] = 'Outubro'
    month[10] = 'Novembro'
    month[11] = 'Dezembro'
    return this.dia() + ' de ' + month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString() + '      ' + (d.getHours()) + ':' + (d.getMinutes())
  }
}

module.exports = Helper
